<template>
  <b-container fluid class="rarity">
    <div class="top-divider"></div>

    <!-- <span class="square-top" /> -->
    <b-row>
      <h2 class="title">Rarity</h2>
      <div class="rarity-content align-items-start align-items-md-center">
        <b-col cols="6" sm="4" md="2" class="rarity-badge d-flex flex-column align-items-center">
          <div class="rarity-image">
            <img src="@/assets/rebrand/home/rarity/common-badge.png" alt="" class="img-fluid" />
            <span class="hover-highlight" />
          </div>
          <img
            src="@/assets/rebrand/home/rarity/common-name.png"
            alt=""
            class="rarity-name img-fluid"
          />
        </b-col>
        <b-col cols="6" sm="4" md="2" class="rarity-badge d-flex flex-column align-items-center">
          <div class="rarity-image">
            <img src="@/assets/rebrand/home/rarity/epic-badge.png" alt="" class="img-fluid" />
            <span class="hover-highlight" />
          </div>
          <img
            src="@/assets/rebrand/home/rarity/epic-name.png"
            alt=""
            class="rarity-name img-fluid"
          />
        </b-col>
        <b-col cols="6" sm="4" md="2" class="rarity-badge d-flex flex-column align-items-center">
          <div class="rarity-image">
            <img src="@/assets/rebrand/home/rarity/legendary-badge.png" alt="" class="img-fluid" />
            <span class="hover-highlight" />
          </div>
          <img
            src="@/assets/rebrand/home/rarity/legendary-name.png"
            alt=""
            class="rarity-name img-fluid"
          />
        </b-col>
        <b-col cols="6" sm="4" md="2" class="rarity-badge d-flex flex-column align-items-center">
          <div class="rarity-image">
            <img src="@/assets/rebrand/home/rarity/rare-badge.png" alt="" class="img-fluid" />
            <span class="hover-highlight" />
          </div>
          <img
            src="@/assets/rebrand/home/rarity/rare-name.png"
            alt=""
            class="rarity-name img-fluid"
          />
        </b-col>
        <b-col cols="6" sm="4" md="2" class="rarity-badge d-flex flex-column align-items-center">
          <div class="rarity-image">
            <img src="@/assets/rebrand/home/rarity/super-rare-badge.png" alt="" class="img-fluid" />
            <span class="hover-highlight" />
          </div>
          <img
            src="@/assets/rebrand/home/rarity/super-rare-name.png"
            alt=""
            class="rarity-name img-fluid"
          />
        </b-col>
      </div>
    </b-row>
    <span class="square-bottom" />
    <img src="@/assets/rebrand/home/rarity-element.png" alt="rarity" class="rarity-element" />
    <img src="@/assets/mobile/rarity-shape2.png" alt="rarity shape" class="rarity-shape2 -mb" />
    <img src="@/assets/mobile/glow-violet.png" alt="glow violet" class="glow-violet -mb" />
    <img src="@/assets/rebrand/home/rarity-bg-1.png" alt="rarity" class="rarity-bg" />
  </b-container>
</template>
<script>
export default {
  name: 'Rarity',
};
</script>
